import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Aug 22 2018
 * @author BPo
 * @author SKu
 */
import { OptionalDesc, RecursiveDescVisitor, Utils, ValidationError, ValidationLevel } from '@logio/common-be-fe';
import * as React from 'react';
import { Field as FinalField, FormSpy } from 'react-final-form';
import logger from '../../../shared/logger';
import translate from '../../i18n/translate';
import { FormContextConsumer } from '../Form/FormContext';
import { FormFieldTypeEnum } from './FormFieldTypeEnum';
import { automaticSelector, hybridSelector } from './utils/selectors';
import { shouldRenderField } from './utils/shouldRenderField';
import { getTransform } from './utils/transforms';
/**
 * Render a specific element based on the fieldType property.
 * @param field The form field element
 * @param props The form field props
 * @param hiddenFields Form elements that will be removed on the submit event.
 */

export var getFinalField = function getFinalField(field, _ref, hiddenFields) {
  var name = _ref.name,
      fieldHide = _ref.fieldHide,
      fieldShow = _ref.fieldShow,
      _ref$clearValue = _ref.clearValue,
      clearValue = _ref$clearValue === void 0 ? true : _ref$clearValue,
      showIfPlaceholder = _ref.showIfPlaceholder,
      placeholderValues = _ref.placeholderValues;
  return React.createElement(FormSpy, {
    subscription: {
      values: true
    }
  }, function (form) {
    var values = form.values;

    if (!shouldRenderField(fieldHide, fieldShow, values, showIfPlaceholder, placeholderValues)) {
      if (clearValue) {
        hiddenFields.add(name);
        values[name] = undefined;
      }

      return null;
    }

    hiddenFields.delete(name);
    return field;
  });
};
export var CollectLookups =
/*#__PURE__*/
function (_RecursiveDescVisitor) {
  _inherits(CollectLookups, _RecursiveDescVisitor);

  function CollectLookups() {
    _classCallCheck(this, CollectLookups);

    return _possibleConstructorReturn(this, _getPrototypeOf(CollectLookups).call(this, new Set()));
  }

  _createClass(CollectLookups, [{
    key: "visitProp",
    value: function visitProp(propDesc) {
      var ret = _get(_getPrototypeOf(CollectLookups.prototype), "visitProp", this).call(this, propDesc);

      console.log('now', propDesc);

      if (Utils.isString(propDesc.parser.constructor.name)) {
        ret.add(propDesc.parser.constructor.name);
      }

      return ret;
    }
  }]);

  return CollectLookups;
}(RecursiveDescVisitor);
/**
 * Execute validation in sequence: required > customValidate? > data dictionary validate
 * @param propDesc Description object of the form field
 * @param customValidate Custom validation will be evaluated after required validation and before all validation from the data dictionary.
 * @param transform Transform value to specific value description object. This should be passed for non-primitive values (probably).
 * @param type
 */

var validate = function validate(propDesc, customValidate, transform, type, optional) {
  return function (valueParam, allValues) {
    var value = valueParam; // Not optional description and value not defined

    if (!(propDesc instanceof OptionalDesc)) {
      if (Utils.isValueMissing(value) && !optional) {
        return new ValidationError('err-required');
      } // FIXME: This is maybe a week implementation. But now it works..


      if (Utils.isArray(value) && (value.length === 0 || value.some(function (item) {
        return Utils.isValueMissing(item);
      })) && !optional) {
        return new ValidationError('err-required');
      }
    }

    if (value) {
      if (Utils.isArray(value)) {
        // Array is empty, nothing to check now
        if (!value.length) {
          return null;
        } // Input range should have both values


        if (!optional && type === FormFieldTypeEnum.InputRange && value.some(function (item) {
          return Utils.isValueMissing(item);
        })) {
          return new ValidationError('err-required');
        }
      }

      if (transform) {
        value = transform(value);
      }
    }

    if (customValidate) {
      return customValidate(value, allValues);
    }

    var validationResult = propDesc.validate(value, ValidationLevel.Fast);
    var validationError = validationResult.valid ? undefined : validationResult;
    return validationError;
  };
};
/**
 * Render a specific element based on the fieldType property or automatic selection.
 * @param props
 * @param propDesc Optional Description of the field
 * @param options Optional options in pure and virtualized variant
 * @param dependsOn Optional
 */


var renderField = function renderField(props, hiddenFields, propDesc, options, placeholderValues) {
  var adapterElement = props.fieldType ? hybridSelector(props.fieldType, propDesc, options, props.className, props.fieldNoLabel) : automaticSelector(propDesc, options, props.fieldReadOnly, props.fieldNoLabel, props.className); // No adapter found

  if (!adapterElement) {
    logger.error('Form adapter not found. NameKey:', (propDesc.description || {}).nameKey);
    return React.createElement(React.Fragment, null);
  }

  return getFinalField(React.createElement(FinalField, {
    labelTooltipText: props.labelTooltipText,
    component: adapterElement.adapter,
    label: translate("forms_labels_".concat(propDesc.description.nameKey)),
    name: props.name,
    placeholder: Utils.isString(props.fieldPlaceholder) ? translate(props.fieldPlaceholder) : props.fieldPlaceholder,
    type: adapterElement.type,
    placeholderValues: placeholderValues,
    validate: validate(propDesc, props.validate, getTransform(propDesc), adapterElement.type, props.optional)
  }), props, hiddenFields);
};
/**
 * A component that takes FieldProps and renders an individual field. All form elements must
 * be wrapped by this field.
 */


export var Field =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Field, _React$PureComponent);

  function Field() {
    _classCallCheck(this, Field);

    return _possibleConstructorReturn(this, _getPrototypeOf(Field).apply(this, arguments));
  }

  _createClass(Field, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(FormContextConsumer, null, function (formContext) {
        if (!formContext.formStore.fields || formContext.formStore.fields.get(_this.props.name)) {
          var description = formContext.descriptions[_this.props.name];
          var options = Utils.isValueMissing(description) ? undefined : formContext.formStore.getOptions(description);
          return _this.props.component ? // Render a specific element based on the fieldType property.
          getFinalField(React.createElement(FinalField, {
            labelTooltipText: _this.props.labelTooltipText,
            name: _this.props.name,
            type: _this.props.fieldType,
            component: _this.props.component,
            validate: validate(description, _this.props.validate, getTransform(description), undefined, _this.props.optional),
            placeholder: _this.props.fieldPlaceholder,
            placeholderValues: _this.props.placeholderValues,
            description: description,
            options: options
          }), _this.props, formContext.hiddenFields) : renderField(_this.props, formContext.hiddenFields, description, options, _this.props.placeholderValues);
        }

        return null;
      });
    }
  }]);

  return Field;
}(React.PureComponent);
Field.defaultProps = {
  fieldPlaceholder: ''
};